const createPersonPayload = (initialPayload, requiredAttributes, optionalAttributes) => {
  return getValidAttributes(initialPayload, requiredAttributes, optionalAttributes)
}

const cleanPersonPayload = (finalPayload) => {
  if (
    finalPayload.attributes.nationalities &&
    finalPayload.attributes.nationalities.findIndex((item) => item === 'FRANCE') > -1
  ) {
    delete finalPayload.attributes.residence_permit_number
  }
  if (finalPayload.attributes.marital_status === 'married') {
    delete finalPayload.attributes.pacs_convention
  } else if (finalPayload.attributes.marital_status === 'pacs') {
    delete finalPayload.attributes.matrimonial_regime
  } else if (finalPayload.attributes.marital_status) {
    delete finalPayload.attributes.pacs_convention
    delete finalPayload.attributes.matrimonial_regime
  }
  if (finalPayload.attributes.birth_country && finalPayload.attributes.birth_country !== 'FRANCE') {
    delete finalPayload.attributes.birth_insee_code
  }

  return finalPayload
}

const getValidAttributes = (attributes, requiredAttributes, optionalAttributes) => {
  const validAttributes = {}
  const allAttributes = [...requiredAttributes, ...optionalAttributes,]
  allAttributes.forEach((attribute) => {
    if (
      typeof attributes[attribute] === 'string' ||
      attributes[attribute] instanceof String ||
      Array.isArray(attributes[attribute])
    ) {
      if (attributes[attribute].length > 0) {
        validAttributes[attribute] = attributes[attribute]
      } else if (attributes[attribute].length === 0) {
        validAttributes[attribute] = null
      }
    } else {
      validAttributes[attribute] = attributes[attribute]
    }
  })

  return {
    type: 'people',
    attributes: validAttributes,
  }
}

const fetchCustomerFields = (customer, controls, requiredAttributes, optionalAttributes) => {
  const allFields = requiredAttributes.concat(optionalAttributes)

  const result = allFields.reduce((result, item) => {
    result[item] = {
      value: customer[item],
      control: controls[item],
      type: findType(item),
    }

    return result
  }, {})

  return result
}

const findType = (field) => {
  if (bankInfosFields.includes(field)) {
    return 'bank_infos'
  } else if (contactInfosFields.includes(field)) {
    return 'contact_infos'
  } else {
    return 'personal_infos'
  }
}

const getFieldsByProperty = (allFields, localFields) => {
  const result = localFields.filter((field) => allFields.includes(field))

  return result.reduce((byKey, item) => {
    const value = item

    byKey[value] = true

    return byKey
  }, {})
}

const personalInfosFields = [
  'civility',
  'last_name',
  'first_name',
  'birth_name',
  'other_names',
  'date_of_birth',
  'birth_country',
  'birth_insee_code',
  'nationalities',
  'residence_permit_number',
  'marital_status',
  'matrimonial_regime',
  'pacs_convention',
  'profession',
  'profession_sector',
  'reference_tax_number',
  'tax_country',
  'tax_address_line_1',
  'tax_address_line_2',
  'tax_address_line_3',
  'tax_insee_code',
]

const contactInfosFields = [
  'email',
  'home_phone_number',
  'mobile_phone_number',
  'home_country',
  'home_address_line_1',
  'home_address_line_2',
  'home_address_line_3',
  'home_insee_code',
]

const bankInfosFields = ['account_iban', 'bank_bic', 'account_holder',]

const getRoundedCompletion = (completion) => {
  if (typeof completion === 'string') {
    return getRoundedCompletion(parseFloat(completion))
  }

  return Math.floor(completion)
}
const getCompletionLabel = ($t, $n, key, completion) => {
  const rounded = getRoundedCompletion(completion)
  const percent = $n(rounded / 100, 'percent')

  return $t(key, { percent, })
}

const mapWarnings = (fields, requiredData) => {
  const { missingAttributes, missingDocuments, refusedAttributes, refusedDocuments, } = fields

  // concat missing + refused for each part
  const listFields = missingAttributes.concat(refusedAttributes)
  const listDocs = missingDocuments.concat(refusedDocuments)
  const requiredDocsTotal = requiredData.requiredDocuments.length
  const requiredAttributes = requiredData.requiredAttributes
  if (!requiredDocsTotal || !requiredAttributes) {
    return {}
  }
  const requiredPersonalTotal = personalInfosFields.filter((value) => requiredAttributes.includes(value))
    .length
  const requiredContactTotal = contactInfosFields.filter((value) => requiredAttributes.includes(value)).length
  const requiredBanksTotal = bankInfosFields.filter((value) => requiredAttributes.includes(value)).length

  // divide fields warnings into sections
  const missingPersonalFields = personalInfosFields.filter((value) => listFields.includes(value))
  const missingcontactFields = contactInfosFields.filter((value) => listFields.includes(value))
  const missingBankFields = bankInfosFields.filter((value) => listFields.includes(value))

  const resultDocs = requiredDocsTotal - listDocs.length

  const filledFields = {
    personal: requiredPersonalTotal - missingPersonalFields.length,
    contact: requiredContactTotal - missingcontactFields.length,
    bank: requiredBanksTotal - missingBankFields.length,
  }
  const res = {
    personal_infos: {
      count: missingPersonalFields.length,
      percent: (filledFields.personal / requiredPersonalTotal) * 100 || 0,
    },
    contact_infos: {
      count: missingcontactFields.length,
      percent: (filledFields.contact / requiredContactTotal) * 100 || 0,
    },
    bank_infos: {
      count: missingBankFields.length,
      percent: (filledFields.bank / requiredBanksTotal) * 100 || 0,
    },
    documents: {
      count: listDocs.length,
      percent: (resultDocs / requiredDocsTotal) * 100 || 0,
    },
  }

  return res
}

export {
  mapWarnings,
  createPersonPayload,
  cleanPersonPayload,
  fetchCustomerFields,
  getFieldsByProperty,
  contactInfosFields,
  bankInfosFields,
  personalInfosFields,
  getCompletionLabel,
}
